// extracted by mini-css-extract-plugin
export default {"cls1":"v64CnFLm43SClNcooMA_","cls2":"IUBZNjJ50E2PnRaOcIpE v64CnFLm43SClNcooMA_"};